module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += 'export default __webpack_public_path__ + "scripts/resources/assignments/en/Stoichiometry/oracle-temp-3-not-hidden/solutions.json";';

}
return __p
}